<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer001">
<h1 class="Prelims-head"><a id="_idTextAnchor000"></a>About the Author</h1>
<p class="Prelims-main">Once upon a time, Andrew Ridgway, who was born in 1973, wanted to be a writer. But life had other ideas, and so for over 21 years he has worked as a theatre nurse.</p>
<p class="Prelims-main">In his first published book, which collects together his humanistic themed poetry, Andrew is processing difficult events in his life. These include recent experiences being re-deployed to his hospital’s intensive care unit during the Covid 19 pandemic.</p>
<p class="Prelims-main">He is currently working on a second book of poetry based on love and relationships.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398433502_EPUB.vue?16423628